import { useState } from "react";
import { Dialog, DialogActions, DialogContent, Button, IconButton } from "@mui/material";
import OrganizationProfileStepper from "./organization-profile-stepper";
import useOrganizationProfileStepper from "hooks/useOrganizationProfileStepper";
import { useSelector } from "react-redux";
import { LoadingButton } from "@mui/lab";
import { Close } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { selectGasServedHasSelectedAreas } from "./organization-profile-stepper/slice";
import useConfirmation from "hooks/useConfirmation";

const OnboardingPopup = ({ 
    open, 
    onClose,
    doNotShowAgain,
    onNotShowAgainClick,
    isSavingRemainder
}) => {
    const { t } = useTranslation();
    const [actionVisible, setActionVisible] = useState(true);
    const { submitUpdate, isReady } = useOrganizationProfileStepper({ enabled: open });

    const saving = useSelector(
        (state) => state.organizationStepperState.saving
    );

    const hasPendingGasAreas = useSelector(selectGasServedHasSelectedAreas);

    const { withConfirmation, confirmationDialog } = useConfirmation({
        shouldConfirm: hasPendingGasAreas,
        titleMessage: t("messages.unadded_geographic_areas"),
        popupMessage: t("messages.unadded_geographic_areas_description"),
        confirmLabel: t("buttons.continue_without_adding"),
        cancelLabel: t("buttons.go_back")
    });

    const handleDialogClose = (event, reason) => {
        if (reason === "backdropClick") {
            return;
        }
        withConfirmation(onClose)(event, reason);
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={handleDialogClose}
                fullWidth
                maxWidth="lg"
                sx={{
                    "& .MuiDialog-paper": {
                        py: 0,
                    },
                }}
            >
                <IconButton
                    aria-label="close"
                    onClick={withConfirmation(onClose)}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 4,
                        zIndex: 15
                    }}
                >
                    <Close />
                </IconButton>

                <DialogContent dividers sx={{ p: 0 }}>
                    <OrganizationProfileStepper
                        complete={false}
                        popupMode={true}
                        onComplete={() => submitUpdate()}
                        actionsDisabled={!isReady}
                    />
                </DialogContent>
                {actionVisible && (
                    <DialogActions>
                        {doNotShowAgain && (
                            <LoadingButton 
                                color="secondary" 
                                variant="outlined" 
                                loading={isSavingRemainder}
                                onClick={onNotShowAgainClick}
                            >
                                Don't show again
                            </LoadingButton>
                        )}

                        <LoadingButton color="secondary" variant="outlined" 
                            loading={isSavingRemainder}
                            onClick={withConfirmation(onClose)}
                        >
                            Remind me later
                        </LoadingButton>

                        <LoadingButton color="secondary" variant="outlined"
                            loading={saving}
                            disabled={!isReady}
                            onClick={withConfirmation(() => {
                                submitUpdate().then((success) => {
                                    if (success) {
                                        onClose();
                                    }
                                });
                            })}
                        >
                            Save
                        </LoadingButton>

                    </DialogActions>
                )}
            </Dialog>

            {confirmationDialog}
        </>
    );
};

export default OnboardingPopup;
